// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file index.ts
 * @input Imports hooks from individual files
 * @output Exports all hooks
 * @position Hook entry point; re-exported by /packages/core/src/index.ts
 *
 * SYNC: When modified, update this header
 */
export { hasActiveFocusTrapEscape, isImeKeyEvent, useFocusTrap } from "./useFocusTrap.js";
export { useAnnounce } from "./useAnnounce.js";
export { useClipboard } from "./useClipboard.js";
export { useGridFocus } from "./useGridFocus.js";
export { useListFocus } from "./useListFocus.js";
export { useTreeFocus } from "./useTreeFocus.js";
export { useHotkeys } from "./useHotkeys.js";
export { useTypeahead } from "./useTypeahead.js";
export { useKeyboardHint } from "./useKeyboardHint.js";
export { useMediaQuery } from "./useMediaQuery.js";
export { useOverflow } from "./useOverflow.js";
export { useScrollOverflow } from "./useScrollOverflow.js";
export { useScrollLock } from "./useScrollLock.js";
export { useEntryAnimation } from "./useEntryAnimation.js";
export { useStreamingText } from "./useStreamingText.js";
export { useImageMode } from "./useImageMode.js";
export { useClickableContainer, INTERACTIVE_SELECTORS } from "./useClickableContainer.js";
export { useInputContainer } from "./useInputContainer.js";
export { useInputStatusIcon } from "./useInputStatusIcon.js";
export { useInteractiveRole } from "./useInteractiveRole.js";
export { useLongPress } from "./useLongPress.js";
export { useDevWarning } from "./useDevWarning.js";
export { useIndicatorFocusRing } from "./useIndicatorFocusRing.js";
export { useContainerReveal } from "./useContainerReveal.js";